/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect, useSelector } from 'react-redux'
import { compose } from 'redux'
import {
  format,
} from 'date-fns'
import {
  PageFooter,
  Group,
  Banner,
  ClientOnly,
} from '..'
import setPageName from '../../utils/pageName'
import handleApiError from '../../utils/handleApiError'
import PlayerApi from '../../utils/playerApi'
import withPlayerApi from '../../hocs/withPlayerApi'
import getCurrentDomain from '../../utils/getCurrentDomain'
import { mergePromotedGroups, mapFromSpecialEvent } from '../../utils/remapPromotedGroupAssets'
import cookies from '../../utils/cookies'
import extractNewsData from '../../utils/extractNewsData'
import {
  CARD_RENDITIONS,
  STV_COOKIES,
  EU_REGION_CODE,
  DEFAULT_GROUPTOKEN,
  PERSONALISED_HERO_SLIDES,
  WAYS_TO_WATCH_INDICATOR,
} from '../../constants'
import { PROMOTED_GROUP_ASSET_OBJECT } from '../../utils/types'
import errorRedirect from '../../utils/errorRedirect'
import getFeaturedEpisode from '../SummaryPage/summaryData/getFeaturedEpisode'
import { trackEvent } from '../../utils/dtmHelpers'
import styles from './styles'

const { STV_GROUPTOKEN, STV_USERID } = STV_COOKIES
const apiParams = ({ order, groupToken }) => ({
  limit: 8,
  orderBy: order,
  groupToken,
})
function showCardTitleInGroup(group) {
  const showCardTitlesOnTypes = ['recommended', 'continueWatching', 'recentlyAdded', 'mostPopular', 'news']
  /* Always show tile titles on */
  if (group.type === 'featured' && group.name === 'Live Channels') return true
  if (group.type === 'featured' && group.name === 'More Information') return true
  if ((group.type === 'programmes' || group.type === 'featured') && group.name === 'New to STV Player') return true
  if ((group.type === 'programmes' || group.type === 'featured') && group.name === 'So...Real') return true
  if (group.type === 'featured' && group.slug === 'stv-featured-seans-scotland-sponsored-by-citylink') return false
  /* Check listed carosels above to show titles on */
  if (showCardTitlesOnTypes.includes(group.type)) return true
  /* Check if there is an episode in the group - hacky checking link */
  const checkFor = ['episode', 'video']
  return Boolean(group.assets?.filter(asset => checkFor.some(v => asset?.link?.includes(`/${v}/`))).length)
}

const getLiveProg = e => ({
  title: e?.title,
  guid: e?.programme && e?.programme?._permalink && e?.programme?.guid,
})

export function BaseHomepage({
  promotedGroups,
  error,
  eventBannerRow,
  firstFeaturedRow,
  currentDomain,
  userPersonalisationOptIn,
  currentlySubscribed,
}) {
  if (error) errorRedirect()

  const playerApiCache = useSelector(stateSelector => stateSelector.playerApiCache?.[`/streams/stv`])
  const playerApi = PlayerApi()
  const [liveProgramme, setLiveProgramme] = useState(null)
  // flag to add or remove the hero titles from featured row
  const isIncludedHeroTitles = true

  useEffect(() => {
    setPageName({
      page: 'homepage',
    })
    if (window?.digitalData.user.loggedIn === '1') trackEvent('launchEvent', {})
    // eslint-disable-next-line consistent-return
    const fetchData = async () => {
      try {
        // round dateTime to the closest 5 minutes
        const minutes = new Date().getMinutes()
        const roundedMinutes = Math.floor(minutes / 5) * 5
        const roundedDateTime = format(new Date().setMinutes(roundedMinutes, 0, 0), 'yyyy-MM-dd HH:mm:ss')
        if (playerApiCache) {
          const { results, reason: scheduleError } = await playerApi({
            path: `/schedule/`,
            query: {
              startTime: `<=${roundedDateTime}`, // use roundedDateTime for caching
              endTime: `>=${roundedDateTime}`,
              orderBy: 'startTime',
              limit: 1,
              channel: 'stv',
            },
          })

          if (scheduleError) return { error: handleApiError({ apiError: scheduleError }) }

          const filteredResults = results
            .map(getLiveProg)

          setLiveProgramme(filteredResults[0])
        }
      } catch (err) {
        setLiveProgramme(null)
      }
    }
    if (WAYS_TO_WATCH_INDICATOR) {
      fetchData()
    }
  }, [playerApiCache])

  const promotedGroupss = promotedGroups?.filter(promotedGroup => ((promotedGroup.type !== 'recommended' || (promotedGroup.type === 'recommended' && userPersonalisationOptIn)) ? promotedGroup : null))
  const heroTitles = eventBannerRow?.assets?.map(asset => asset.linkGuid)
  const newFeaturedRow = {
    assets: isIncludedHeroTitles ? firstFeaturedRow?.assets : firstFeaturedRow?.assets?.filter(asset => (!heroTitles.includes(asset.guid))),
    id: firstFeaturedRow?.id,
    type: firstFeaturedRow?.type,
    name: firstFeaturedRow?.name,
  }

  return (
    <main>
      {eventBannerRow && (
        <Group
          key={eventBannerRow.id}
          {...eventBannerRow}
          showTitle={false}
          liveProgramme={liveProgramme}
          specialEvent
        />
      )}
      <div className="page-body">
        {newFeaturedRow && (
          <Group
            key={newFeaturedRow.id}
            groupId={0}
            {...newFeaturedRow}
            showTitle
            large
            page="home"
          />
        )}
        {!currentlySubscribed
        && (
          <ClientOnly>
            <Banner />
          </ClientOnly>
        )}
        {promotedGroupss?.map((group, i) => (group?.assets?.length > 0) && (
          <Group
            key={group.id}
            groupId={i + 1}
            {...group}
            showTitle
            showCardTitle={showCardTitleInGroup(group)}
            page="home"
          />
        ))}
        <PageFooter currentDomain={currentDomain} />
      </div>
      <style jsx>{styles}</style>
    </main>
  )
}

function stringifyError(error) {
  try {
    return JSON.stringify(error)
  } catch (e) {
    return 'Unable to display error details'
  }
}

BaseHomepage.getInitialProps = async ({ playerApi, req, reduxStore }) => {
  try {
    const hostname = req?.headers.host.split(':')[0] || window.location.hostname
    const currentDomain = getCurrentDomain(hostname)
    let groupToken = cookies.get(STV_GROUPTOKEN, req)
    // does the user have no grouptoken, or an EU region grouptoken, (0081 or 0080)?
    if (!groupToken || groupToken[2] === EU_REGION_CODE) {
      // we don't have content to show EU users on the homepage, so just use a default grouptoken
      groupToken = DEFAULT_GROUPTOKEN
    }

    const { results: promotedGroups } = await playerApi({
      path: '/promoted/groups',
      query: {
        groupToken,
        renditions: CARD_RENDITIONS.join(','),
      },
    })

    const mostPopular = promotedGroups && promotedGroups.find(group => group.type === 'mostPopular')
      ? await playerApi({
        path: '/episodes',
        query: apiParams({ order: '-views', groupToken, limit: 12 }),
      })
      : null

    const recentlyAdded = promotedGroups && promotedGroups.find(group => group.type === 'recentlyAdded')
      ? await playerApi({
        path: '/episodes',
        query: apiParams({ order: '-availability.from', groupToken, limit: 12 }),
      })
      : null

    let personalisedRecommendations = null
    // && cookies.get(STV_USERID, req) && cookies.get(STV_PERSONALISATION_OPTIN, req)
    if (promotedGroups && cookies.get(STV_USERID, req) && promotedGroups.find(group => group.type === 'recommended')) {
      const userId = cookies.get(STV_USERID, req)
      personalisedRecommendations = await playerApi({
        path: `/recommended/viewer/${userId}`,
        query: apiParams({ groupToken, limit: 12 }), // limit doesn't do anyting here
      })
    }

    let newsShortform = null
    if (promotedGroups && promotedGroups.find(group => group.type === 'news')) {
      try {
        const newsShort = await fetch('https://news.stv.tv/wp-json/newsatsix/v1/latest?page=1&per_page=24', {
          method: 'GET',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          },
        }).then(r => r.json())

        const extractedData = newsShort.map(r => extractNewsData(r))
        // abandon ship if no items returned
        newsShortform = extractedData.length > 0 ? extractedData : null
      } catch (e) {
        // do nothing
      }
    }

    // eslint-disable-next-line max-len
    const slicedPromotedGroups = promotedGroups?.map(group => ({ ...group, assets: group?.assets?.slice(0, 12) }))

    const mergedGroups = mergePromotedGroups({
      promotedGroups: slicedPromotedGroups,
      mostPopular,
      recentlyAdded,
      personalisedRecommendations,
      newsShortform,
      hostname,
      req,
    })

    const isSpecialEvent = promotedGroups && promotedGroups.find(group => group.type === 'specialEvent')
    let recommendedProgrammes = mergedGroups.find(group => group.type === 'recommended')

    let eventBannerRow
    if (isSpecialEvent) {
      mapFromSpecialEvent({ isSpecialEvent })
      eventBannerRow = mergedGroups.shift()

      await Promise.all(eventBannerRow?.assets?.map(async (asset) => {
        if (!asset.link.includes('/live/') && asset.linkGuid !== null) {
          const { results } = await playerApi({
            path: `/shortform`,
            query: { groupToken, programme_guid: asset.linkGuid },
          })

          if (results) {
            // in future will be multiple as different aspect ratio for mobile
            const autoplayShortform = results?.filter(({ collection }) => collection.guid.includes('autoplay'))[0]

            const autoplayShortformFiltered = {
              videoId: autoplayShortform?.video?.id,
              drmEnabled: autoplayShortform?.programme?.drmEnabled,
              guid: autoplayShortform?.guid,
              videoLength: autoplayShortform?.video?.length,
            }
            // eslint-disable-next-line no-param-reassign
            asset.autoplayShortform = autoplayShortformFiltered
          }
        }
        return asset
      }))

      if (PERSONALISED_HERO_SLIDES > 0 && recommendedProgrammes) {
        const eventBannerRowGuids = eventBannerRow?.assets?.map(asset => asset.linkGuid)
        const recommendedProgrammesGuids = recommendedProgrammes?.assets?.map(asset => asset.linkGuid)
        const filteredRecommendedProgrammes = recommendedProgrammesGuids?.filter(guid => !eventBannerRowGuids.includes(guid))
        recommendedProgrammes = {
          ...recommendedProgrammes,
          assets: recommendedProgrammes?.assets?.filter(asset => filteredRecommendedProgrammes.includes(asset.linkGuid)).slice(0, PERSONALISED_HERO_SLIDES)
            .map(asset => ({ ...asset, recoID: recommendedProgrammes?.recoID })),
        }
        eventBannerRow.assets = eventBannerRow.assets.concat(recommendedProgrammes.assets)
      }

      // get programme info
      await Promise.all(eventBannerRow?.assets?.map(async (asset) => {
        if (!asset.link.includes('/live/') && asset.linkGuid !== null) {
          const { results: programmeData } = await playerApi({
            path: `/programmes/${asset.linkGuid}`,
            query: { groupToken },
          })
          // Get featured episode
          try {
            const featuredEpisode = await getFeaturedEpisode({ programmeData, playerApi, req })
            if (programmeData) {
              const { availableEpisodes, series } = programmeData
              const episodeCount = series?.length > 1 ? `${series.length} series` : (availableEpisodes > 1 ? `${availableEpisodes} Episodes` : featuredEpisode?.duration ?? '')
              const subGenre = availableEpisodes > 1 ? `${availableEpisodes} Episodes` : programmeData?.genre?.subGenre?.name
              asset.genre = programmeData?.genre?.name
              asset.availableEpisodes = asset?.genre === 'Movie' ? subGenre : episodeCount
              asset.isSubtitle = programmeData?.featuredEpisode?.accessibility?.subtitles || false
              asset.audioDescription = featuredEpisode?.audioDescribed || false
              asset.visuallySigned = featuredEpisode?.visuallySigned || false
              asset.isGuidance = programmeData?.featuredEpisode?.accessibility?.guidance || false
            }
          } catch (error) {
            console.log('Error fetching Hero featured episode info for programme: ', asset.linkGuid) // eslint-disable-line
          }
        }

        return asset
      }))
    }

    const firstFeaturedRow = mergedGroups.shift()

    return {
      layout: 'home',
      promotedGroups: mergedGroups,
      eventBannerRow,
      firstFeaturedRow,
      currentDomain,
    }
  } catch (error) {
    console.error({ error }) // eslint-disable-line
    return { error: stringifyError(error) }
  }
}

BaseHomepage.propTypes = {
  promotedGroups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]).isRequired,
      type: PropTypes.string.isRequired,
      assets: PropTypes.arrayOf(PROMOTED_GROUP_ASSET_OBJECT).isRequired,
    })
  ).isRequired,
  eventBannerRow: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    type: PropTypes.string,
    linkGuid: PropTypes.string,
    assets: PropTypes.arrayOf(PROMOTED_GROUP_ASSET_OBJECT).isRequired,
  }),
  firstFeaturedRow: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    type: PropTypes.string,
    assets: PropTypes.arrayOf(PROMOTED_GROUP_ASSET_OBJECT),
    name: PropTypes.string,
  }),
  error: PropTypes.string,
  userPersonalisationOptIn: PropTypes.bool,
  currentlySubscribed: PropTypes.bool,
  currentDomain: PropTypes.string,
}

BaseHomepage.defaultProps = {
  error: '',
  eventBannerRow: null,
  firstFeaturedRow: null,
  userPersonalisationOptIn: false,
  currentlySubscribed: false,
  currentDomain: '',
}

const mapStateToProps = ({
  user: { userPersonalisationOptIn, currentlySubscribed },
}) => ({ userPersonalisationOptIn, currentlySubscribed })

const enhance = compose(
  withPlayerApi,
  connect(mapStateToProps),
)

export default enhance(BaseHomepage)
